import { Box, Container, Grid, useTheme } from '@mui/material'
import React, { useEffect } from 'react'
import { MpTypography } from '../shared'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { ScanWidget } from './HomeViews/ScanWidget'
import useMediaQuery from '@mui/material/useMediaQuery'
import { BrokerListSuspense } from './HomeViews/BrokerListSuspense'
import PaymentDeclinedWidget from '../shared/molecule/PaymentDeclinedWidget'
import { useAppSelector } from '../../app/hooks'
import {
  hasPaymentFailed,
  selectPlatformStatus,
} from '../../redux/product/ProductSlice'

const Home = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const location = useLocation()
  const platformStatus = useAppSelector(selectPlatformStatus)
  const paymentDeclined = hasPaymentFailed(platformStatus)
  const isOnDetails = location.pathname.includes('broker')

  const navigate = useNavigate()

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate('/dashboard')
    }, 250)
    return () => clearTimeout(timeout)
  }, [navigate])

  return (
    <Box>
      <Container fixed maxWidth={'lg'} sx={{ mb: 16, mt: '28px' }}>
        <Grid container columnSpacing={35} rowSpacing={5}>
          {paymentDeclined && (
            <Grid item xs={12}>
              <PaymentDeclinedWidget />
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              my: 8,
            }}>
            <MpTypography variant={'h1'}>Privacy Dashboard</MpTypography>
            <ScanWidget />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            order={{ xs: 2, md: 1 }}
            sx={{ display: isMobile && isOnDetails ? 'none' : 'block' }}>
            <MpTypography variant={'h2'} sx={{ mb: 6 }}>
              Websites selling your data
            </MpTypography>
            <BrokerListSuspense />
          </Grid>
          <Outlet />
        </Grid>
      </Container>
    </Box>
  )
}

export default Home
